export const Loader = () => (
  <div className="loader">
    Loading...
    <style jsx>{`
      .loader {
        display: flex;
        justify-content: center;
        margin: 50px auto;
      }
    `}</style>
  </div>
);
